
import { defineComponent } from "@vue/runtime-core"

export default defineComponent({
    props: {
        speed: { type: Number, default: 1.8 },
        width: { type: String, default: '80%' }
    }
});
